import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { OmniConfigurationState } from '../reducers/omni-configuration.reducer';
import * as selectors from '../selectors/omni-configuration.selectors';

@Injectable({
  providedIn: 'root'
})
export class OmniConfigurationFacadeService extends FacadeService {
  constructor(public override store: Store<OmniConfigurationState>) {
    super(store);
  }

  nameOmni$ = this.storeSelect(selectors.getNameOmni);
  isActiveOmni$ = this.storeSelect(selectors.getStatusOmni);
  smsSenderOmni$ = this.storeSelect(selectors.getSmsSenderOmni);
  viberSenderOmni$ = this.storeSelect(selectors.getViberSenderOmni);
  accountIdOmni$ = this.storeSelect(selectors.getAccountIdOmni);
  apiTokenOmni$ = this.storeSelect(selectors.getApiTokenOmni);
  notificationEmailOmni$ = this.storeSelect(selectors.getNotificationEmailOmni);
  lookBackDaysOmni$ = this.storeSelect(selectors.getLookBackDaysOmni);
  showUpdateBtn$ = this.storeSelect(selectors.getShowUpdateBtn);
  disableNameValue$ = this.storeSelect(selectors.getDisableNameValue);
  showCancelBtn$ = this.storeSelect(selectors.getShowCancelBtn);
  integrationConfHelpTextStatus$ = this.storeSelect(selectors.getIntegrationConfHelpTextStatus);
  credentialsConfHelpTextStatus$ = this.storeSelect(selectors.getCredentialsConfHelpTextStatus);
  notificationHelpTextStatus$ = this.storeSelect(selectors.getNotificationHelpTextStatus);
  campaignReportingHelpTextStatus$ = this.storeSelect(selectors.getCampaignReportingHelpTextStatus);
  omniDataAreValid$ = this.storeSelect(selectors.getOmniDataAreValid);
  showNameErrorMsg$ = this.storeSelect(selectors.getShowNameErrorMsg);
  showSmsSenderErrorMsg$ = this.storeSelect(selectors.getShowSmsSenderErrorMsg);
  showViberSenderErrorMsg$ = this.storeSelect(selectors.getShowViberSenderErrorMsg);
  showAccountIdErrorMsg$ = this.storeSelect(selectors.getShowAccountIdErrorMsg);
  showApiTokenErrorMsg$ = this.storeSelect(selectors.getShowApiTokenErrorMsg);
  notificationEmailErrorMsg$ = this.storeSelect(selectors.getNotificationEmailErrorMsg);
  lookBackDaysErrorMsg$ = this.storeSelect(selectors.getLookBackDaysErrorMsg);

  get nameOmni() {
    return this.storeSnapshot(this.nameOmni$);
  }

  get isActiveOmni() {
    return this.storeSnapshot(this.isActiveOmni$);
  }

  get smsSenderOmni() {
    return this.storeSnapshot(this.smsSenderOmni$);
  }

  get viberSenderOmni() {
    return this.storeSnapshot(this.viberSenderOmni$);
  }

  get accountIdOmni() {
    return this.storeSnapshot(this.accountIdOmni$);
  }

  get apiTokenOmni() {
    return this.storeSnapshot(this.apiTokenOmni$);
  }

  get notificationEmailOmni() {
    return this.storeSnapshot(this.notificationEmailOmni$);
  }

  get lookBackDaysOmni() {
    return this.storeSnapshot(this.lookBackDaysOmni$);
  }

  get showUpdateBtn() {
    return this.storeSnapshot(this.showUpdateBtn$);
  }

  get omniDataAreValid() {
    return this.storeSnapshot(this.omniDataAreValid$);
  }

  getOmniBody() {
    const integrationCode = this.nameOmni;
    const smsSender = this.smsSenderOmni;
    const viberSender = this.viberSenderOmni;
    const accountId = this.accountIdOmni;
    const apiToken = this.apiTokenOmni;
    const notificationEmail = this.notificationEmailOmni;
    const lookBackDays = this.lookBackDaysOmni;
    const status = this.isActiveOmni;

    const omniBody = {
      integrationCode,
      deleted: status,
      integrationConfig: {
        integrationSystem: 'MSTAT_VIBER_SMS_V2',
        integrationDisplayName: integrationCode,
        executionNotificationReceiver: notificationEmail,
        smsSender,
        viberSender,
        accountId,
        reportingConfiguration: {
          lookbackDays: lookBackDays,
        },
      },
      endpointConfiguration: {
        code: integrationCode,
        endpointConfig: {
          type: 'HTTP',
        },
        credentialConfig: {
          type: 'TOKEN',
          bypassEncryption: false,
          token: apiToken,
        },
      },
    };

    return omniBody;
  }
}
